<template>
  <div>
    <v-toolbar dark class="primary">
      <v-toolbar-side-icon @click.native.stop="sideNav = !sideNav" v-if="$vuetify.breakpoint.mdAndDown"></v-toolbar-side-icon>
      <v-toolbar-title class="nar">
        <v-layout align-center>
          <img src='@/assets/vite-logo.jpg' alt="" height="36px" v-if="isShowLogo('production')">
          <img src='@/assets/maximus-en.png' alt="" height="96px" v-if="isShowLogo('far800') && currentLang === 'en'">
          <img src='@/assets/maximus-ch.png' alt="" height="90px" v-if="isShowLogo('far800') && currentLang === 'zhHans'">
          <img src='@/assets/fsd915.png' alt="" height="36px" v-if="isShowLogo('fsd915')">
          <img src='@/assets/shiprateshop.png' alt="" height="96px" v-if="isShowLogo('eagle')">
          <v-icon left dark class="ml-3">{{userIcon}}</v-icon>
        </v-layout>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <PromotionWidget />
      <AnnouncementWidget v-if="isUserLogined && !isAdmin" />

      <v-toolbar-items v-if="!$vuetify.breakpoint.mdAndDown">
        <template v-for="item in items.filter(item => !item.disabled)">
          <v-menu offset-y v-if="!item.link && item.subItems" :key="item.link" :class="'hidden-sm-and-down'">
            <template>
              <v-list dark class="primary">
                <template v-for="subItem in item.subItems">
                  <v-list-tile v-if="!subItem.disabled" :key="subItem.title" @click="menuClick(subItem)" :id="subItem.name">
                    <v-list-tile-title>{{ subItem.name }}</v-list-tile-title>
                  </v-list-tile>
                </template>
              </v-list>
            </template>
            <template #activator="data" @click.stop="menuClick(item)" >
              <v-btn  flat dark :class="getManualClass(item)" v-on="data.on" :id="item.name">{{item.name}}</v-btn>
            </template>
          </v-menu>
          <v-btn v-else flat dark @click.stop="menuClick(item)" :key="item.link">{{item.name}}</v-btn>
        </template>
        <v-menu v-if="isUserLogined" offset-y :class="'hidden-sm-and-down'">
          <template v-slot:activator="{ on }">
            <v-btn @click.stop="on.click" style="box-shadow: none" color="primary">
              <v-icon dark>manage_accounts</v-icon>
            </v-btn>
          </template>
          <v-list dark class="primary" >
            <v-list-tile v-for="account in accounts" :key="account.key">
              <v-btn flat dark @click.stop="switchToAccount(account.name)">
                <v-icon left dark>{{staffIcons(account.role)}}</v-icon>
                {{account.name}}
              </v-btn>
            </v-list-tile>
            <v-list-tile v-if="mainAccount || isUser">
              <v-btn flat dark @click.stop="switchToAccount((mainAccount && `${mainAccount.name}--Individual`) || ($store.getters.userExtra && `${$store.getters.userExtra.name}--Individual` ))">
                <v-icon left dark>perm_identity</v-icon>
                {{$t('individual')}}
              </v-btn>
            </v-list-tile>
            <v-list-tile v-if="!isAdmin">
              <v-btn to="/profile" flat dark>
                <v-icon left dark>account_circle</v-icon>
                {{ $t('profile') }}
              </v-btn>
            </v-list-tile>
            <v-list-tile>
              <v-btn v-if="isUserLogined" flat dark @click="onLogout" id="logout">
                <v-icon left dark>exit_to_app</v-icon>
                {{ $t('logout') }}
              </v-btn>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn
          flat
          @click="switchLang">
          {{ currentLang === 'en' ? '中文' : 'English'}}
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer v-model="sideNav" temporary absolute>
      <v-list>
        <template v-for="item in items.filter(item => item.isShownOnSmallDevices && !item.disabled)">
          <v-list-group
            v-model="item.active" 
            :key="item.link" 
            v-if="!item.link && item.subItems"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-action><v-icon>tablet</v-icon></v-list-tile-action>
                <v-list-tile-content>{{item.name}}</v-list-tile-content>
              </v-list-tile>
            </template>
            <v-list-tile v-for="subItem in item.subItems.filter(item => item.isShownOnSmallDevices && !item.disabled)" :key="subItem.name" @click="$router.push(subItem.link)">
              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.name }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else @click="$router.push(item.link)" :key="item.link" >
            <v-list-tile-action><v-icon>tablet</v-icon></v-list-tile-action>
            <v-list-tile-content>{{item.name}}</v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
      <v-list v-if="isUserLogined">
        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-action><v-icon>manage_accounts</v-icon></v-list-tile-action>
              <v-list-tile-content>Accounts</v-list-tile-content>
            </v-list-tile>
          </template>
          <v-list-tile v-for="account in accounts" :key="account.key" @click.stop="switchToAccount(account.name)">
            <v-list-tile-action><v-icon>{{staffIcons(account.role)}}</v-icon></v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{account.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="mainAccount || isUser" @click.stop="switchToAccount((mainAccount && mainAccount.name) || ($store.getters.userExtra && $store.getters.userExtra.name))">
            <v-list-tile-action><v-icon>perm_identity</v-icon></v-list-tile-action>
            <v-list-tile-content>{{$t('individual')}}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="!isAdmin" @click="$router.push('profile')">
            <v-list-tile-action><v-icon>account_circle</v-icon></v-list-tile-action>
            <v-list-tile-content>{{$t('profile')}}</v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="isUserLogined" @click="onLogout" id="logout">
            <v-list-tile-action><v-icon>exit_to_app</v-icon></v-list-tile-action>
            <v-list-tile-content>{{ $t('logout') }}</v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
      <v-list>
        <v-list-tile
          @click="switchLang">
          <v-list-tile-action>
            <v-icon>translate</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{ currentLang === 'en' ? '中文' : 'English' }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-spacer></v-spacer>
      <v-footer>
        <v-layout><v-spacer></v-spacer><v-flex md4>{{ $t('version') }}: {{version}}</v-flex></v-layout>
      </v-footer>
    </v-navigation-drawer>
    <v-card>
      <v-snackbar
        :top="true"
        :color="toastColor"
        :timeout="30000"
        v-model="toastEnable"
      >
        {{ toastText }}
        <v-btn dark flat @click.stop="closeToast">X</v-btn>
      </v-snackbar>
    </v-card>
    <SimpleTextPopup
      v-model="isReloadNeeded"
      v-if="isReloadNeeded"
      hideLftBtn
      :title="$t('newRelease')"
      :rightButtonText="$t('reload')"
      :rightMethod="reloadPage">
      <template v-slot:input>
        <v-container>
          <v-flex style="white-space: pre-wrap; ">{{reloadPageText}}</v-flex>
        </v-container>
      </template>
      </SimpleTextPopup>
    <SimpleTextPopup
      v-model="isSysUpdating"
      v-if="isSysUpdating"
      hideLftBtn
      hideRgtBtn
    >
      <template v-slot:input>
        <v-container>
          <v-layout justify-center>
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <v-flex style="white-space: pre-wrap; ">{{ updatingText }}</v-flex>
        </v-container>
      </template>
      </SimpleTextPopup>
      <v-dialog v-model="submitting" fullscreen full-width>
        <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.75);">
          <v-layout justify-center align-center>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
      <FormSubmitPopup
      :title="$t('featureApplication')"
      v-model="applicationDialog"
      v-if="applyFeature"
      :leftButtonText="$t('back')"
      :leftMethod="goBack"
      medium
      :isShowSettingIcon="false"
      :isEscClose="false"
      @popupClose="applicationDialog = false"
      :hideRgtBtn="existApplication"
      :rightButtonDisabled="uploadFiles.length < 1"
      :rightMethod="submitApplication"
      :rightButtonText="$t('submit')">
      >
        <template v-slot:input>
          <v-container>
            <v-layout v-if="existApplication">
              <v-layout row align-center justify-space-around>
                <div class="title">{{$t('featureApplicationPending')}}</div>
                <v-btn @click="showCommentsDialog">{{$t('clickToSupport')}}</v-btn>
              </v-layout>
                <ChatRoom
                v-model="commentsDialog"
                v-if="commentsDialog"
                :docPath="['featureApplication', featureApplication._key]"
                :comments="featureApplication.comments"
                :createConnection="true"
                >
                <template v-slot:issue>
                  <v-card hover raised>
                    <v-card-text>
                      <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('createTime') }}: {{ toTimestampString(featureApplication.createTime) }}</div>
                      <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('tenant') }}: {{ featureApplication.name }}</div>
                      <div class="cardTitle" style="overflow-wrap: break-word;">{{ $t('featureApplication') }}: {{ featureApplication.feature }}</div>
                      <br />
                      <div class="cardTitle" style="overflow-wrap: break-word;">
                        {{ $t('files') }}:
                      <v-btn  @click="downloadFile(featureApplication.uploadFiles[0])" >{{ featureApplication.uploadFiles[0].name }}</v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </template>
              </ChatRoom>
            </v-layout>
            <v-layout v-else align-center justify-center fill-height column>
                <div class="title">{{ $t('featureApplicationTips') }}</div>
                <v-container fluid class="downLoadBox">
                  <v-flex sm12 md4>
                    <v-btn large color="primary" flat @click.stop="downloadTemplate">
                    <v-icon dark large class="mx-2">cloud_download</v-icon>
                    {{ $t('downloadTemplate') }}
                  </v-btn>
                  </v-flex>
                </v-container>
                  <UploadFileWidget
                      v-model="uploadFiles"
                      ref="fileUploader"
                      type="file"
                      :maxFiles="1">
                  </UploadFileWidget>
            </v-layout>
          </v-container>
        </template>
    </FormSubmitPopup>
  </div>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'
import PromotionWidget from './PromotionWidget'
import FormSubmitPopup from './FormSubmitPopup'
import UploadFileWidget from './UploadFileWidget'
import ChatRoom from '@/components/ChatRoom'
import AnnouncementWidget from './AnnouncementWidget'
import routeDefinition from '@/router/routeDefinition'
import { authMixin } from '@/router/functionalityAuth'
import {getConditionalRoutesWithDifferentEnv, toTimestampString} from '@/utils/tools'
import { getLang } from '@/i18n'
import { thirdPartModuleConfig } from '../../config/moduleConfig'

export default {
  name: 'navbar',
  mixins: [authMixin],
  components: {
    SimpleTextPopup,
    PromotionWidget,
    AnnouncementWidget,
    FormSubmitPopup,
    ChatRoom,
    UploadFileWidget
  },
  data () {
    return {
      sideNav: false,
      announcementToggle: false,
      submitting: false,
      currentLang: getLang(),
      applicationDialog: false,
      hasAvailableToShip: false,
      uploadFiles: [],
      commentsDialog: false
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.isUserTenant) {
        this.$store.dispatch('getBeforeShipmentForecasts', {tenantKey: this.isUserTenant})
          .then((querySnapshot) => {
            this.hasAvailableToShip = !querySnapshot.empty
          })
      }
    }, 1000)
  },
  watch: {
    applyFeature (value) {
      if (value) {
        this.applicationDialog = true
      }
    }
  },
  computed: {
    mainAccount () {
      return this.$store.getters.mainAccount
    },
    roles () {
      return this.$store.getters.user && this.$store.getters.user.roles
    },
    env () {
      return process.env.NODE_ENV
    },
    isThreePartEnv () {
      return Object.keys(thirdPartModuleConfig).includes(this.env)
    },
    items () {
      let menuItems = [
        {
          name: this.$t('signup'),
          link: '/signup',
          isShownOnSmallDevices: true
        },
        {
          name: this.$t('signin'),
          link: '/signin',
          isShownOnSmallDevices: true
        }
      ]
      if (this.isUserLogined) {
        menuItems = [
          {
            name: this.$t('offer'),
            link: '/offer',
            isShownOnSmallDevices: true,
            auth: this.getAuthConfig('offer'),
            module: ['offerAndTask']
          },
          {
            name: this.$t('task'),
            link: '/task',
            isShownOnSmallDevices: true,
            auth: this.getAuthConfig('task'),
            module: ['offerAndTask']
          },
          {
            name: this.$t('prescan'),
            isShownOnSmallDevices: true,
            link: '/prescan',
            disabled: !this.activatePrescan,
            auth: this.getAuthConfig('prescan'),
            module: ['shipment']
          },
          {
            name: this.$t('inbound'),
            link: '/inbound',
            isShownOnSmallDevices: true,
            disabled: this.isWarehouseForecastFeature,
            auth: this.getAuthConfig('inbound'),
            module: ['label', 'shipment']
          },
          {
            name: this.$t('inbound'),
            isShownOnSmallDevices: true,
            disabled: !this.isWarehouseForecastFeature,
            auth: this.getAuthConfig('inbound'),
            subItems: [
              {
                name: this.$t('standardInbound'),
                link: '/inbound',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('inbound'),
                module: ['label', 'shipment']
              },
              {
                name: this.$t('forecastInbound'),
                link: '/forecastInbound',
                disabled: !this.isAWarehouseForecastFeature,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('forecastInbound'),
                module: ['label', 'shipment', 'forecast']
              },
              {
                name: this.$t('dropshippingInbound'),
                link: '/dropshippingInbound',
                disabled: !this.isWarehouseHasDClassUser,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('DropshippingInbound'),
                module: ['label', 'shipment', 'forecast']
              }
            ]
          },
          {
            name: this.$t('stow'),
            isShownOnSmallDevices: true,
            link: '/WarehouseStow',
            auth: this.getAuthConfig('WarehouseStow'),
            module: ['shipment']
          },
          {
            name: this.$t('outbound'),
            link: this.isUserTenant ? null : '/outBoundHistory', // only show this if not organization
            isShownOnSmallDevices: true,
            module: this.isUser ? ['offerAndTask'] : [],
            subItems: [
              {
                name: this.$t('create'),
                isShownOnSmallDevices: true,
                link: '/toEveryone',
                auth: this.getAuthConfig('toEveryone'),
                module: ['shipment']
              },
              {
                name: this.$t('batchShipment'),
                isShownOnSmallDevices: true,
                link: '/BatchShipment',
                auth: this.getAuthConfig('BatchShipment')
              },
              {
                name: this.$t('status'),
                isShownOnSmallDevices: true,
                link: '/outBoundHistory',
                auth: this.getAuthConfig('outBoundHistory'),
                module: ['shipment']
              },
              {
                name: this.$t('label'),
                isShownOnSmallDevices: true,
                link: '/label',
                auth: this.getAuthConfig('label'),
                module: ['label'],
                feature: 'labelAndOrder', 
                needApplication: !this.visibleBetaFeatures.includes('labelAndOrder')
              },
              {
                name: this.$t('eei'),
                isShownOnSmallDevices: true,
                link: '/eei',
                auth: this.getAuthConfig('eei'),
                disabled: !this.visibleBetaFeatures.includes('labelAndOrder')
              },
              {
                name: this.$t('batchLabel'),
                isShownOnSmallDevices: true,
                link: '/batchLabel',
                auth: this.getAuthConfig('BatchLabel'),
                disabled: !this.visibleBetaFeatures.includes('labelAndOrder')
              },
              {
                name: this.$t('returnPackages'),
                link: '/returnPackages',
                isShownOnSmallDevices: true,
                disabled: !this.isUserTenant,
                auth: this.getAuthConfig('ReturnPackages')
              }
            ]
          },
          {
            name: this.$t('package'),
            link: '/package',
            isShownOnSmallDevices: true,
            disabled: this.isUserTenant,
            auth: this.getAuthConfig('package'),
            module: ['label', 'shipment']
          },
          {
            name: this.$t('order'),
            link: '/tenantOrder',
            isShownOnSmallDevices: true,
            disabled: !this.visibleBetaFeatures.includes('labelAndOrder'),
            auth: this.getAuthConfig('tenantOrder'),
            module: ['label']
          },
          {
            name: this.$t('label'),
            isShownOnSmallDevices: true,
            disabled: !this.isAdmin,
            link: '/labelAdmin',
            auth: this.getAuthConfig('labelAdmin'),
            module: ['label']
          },
          {
            name: this.$t('eei'),
            isShownOnSmallDevices: true,
            link: '/eeiAdmin',
            auth: this.getAuthConfig('eeiAdmin'),
            module: ['label']
          },
          {
            name: this.$t('billing'),
            isShownOnSmallDevices: true,
            disabled: this.isJustUser || !this.isAdmin,
            link: '/billingAdmin',
            auth: this.getAuthConfig('billingAdmin')
          },
          {
            name: this.$t('navbarImport'),
            isShownOnSmallDevices: true,
            disabled: !this.isAdmin,
            link: '/importAdmin',
            auth: this.getAuthConfig('importAdmin'),
            module: ['oversea']
          },
          {
            name: this.$t('navbarImport'),
            isShownOnSmallDevices: true,
            disabled: !(this.isUserTenant && this.visibleBetaFeatures.includes('oversea') && (this.roles.includes('orgOwner') || this.roles.includes('orgOverseaOperator'))),
            link: '/importService',
            auth: this.getAuthConfig('import'),
            module: ['oversea']
          },
          {
            name: this.$t('tools'),
            isShownOnSmallDevices: true,
            subItems: [
              {
                name: this.$t('transfer'),
                link: '/productTransferWarehouse',
                isShownOnSmallDevices: true,
                disabled: this.isUserTenant,
                auth: this.getAuthConfig('productTransferWarehouse')
              },
              {
                name: this.$t('billing'),
                link: this.isWarehouse ? '/billingWarehouse' : '/billingClient',
                isShownOnSmallDevices: true,
                auth: this.isWarehouse ? this.getAuthConfig('billingWarehouse') : this.getAuthConfig('billingClient')
              },
              {
                name: this.$t('support'),
                link: '/support',
                disabled: this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('support')
              },
              {
                name: this.$t('upcInventory'),
                link: '/inventoryWarehouse',
                isShownOnSmallDevices: true,
                disabled: this.isUserTenant,
                auth: this.getAuthConfig('inventoryWarehouse')
              },
              {
                name: this.$t('inboundForecastForNavbar'),
                link: '/orgBoxes',
                isShownOnSmallDevices: true,
                disabled: !this.isWarehouseHasDClassUser,
                auth: this.getAuthConfig('boxes'),
                module: ['forecast']
              },
              {
                name: this.$t('forecastInventory'),
                link: '/ForecastWarehouse',
                isShownOnSmallDevices: true,
                disabled: !this.isWarehouseForecastFeature,
                auth: this.getAuthConfig('ForecastWarehouse'),
                module: ['forecast']
              },
              {
                name: this.$t('statistics'),
                link: '/warehouseStat',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('warehouseStat')
              },
              {
                name: this.$t('importResource'),
                link: '/importResource',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('importResource')
              },
              {
                name: this.$t('efficiencyStatistics'),
                link: '/efficiencyStatistics',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('efficiencyStatistics')
              },
              {
                name: this.$t('audit'),
                link: '/warehouseAudit',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('WarehouseAudit')
              },
              {
                name: this.$t('label'),
                isShownOnSmallDevices: true,
                disabled: !this.isWarehouse || !this.visibleBetaFeatures.includes('labelAndOrder'),
                link: '/labelForWarehouse',
                auth: this.getAuthConfig('labelForWarehouse'),
                module: ['label']
              },
              {
                name: this.$t('documentsManagement'),
                isShownOnSmallDevices: true,
                disabled: !this.isWarehouse,
                link: '/op950Documents',
                auth: this.getAuthConfig('OP950Documents')
              },
              {
                name: this.$t('monthEndClose'),
                isShownOnSmallDevices: true,
                disabled: !this.isShowMonthEndClose,
                link: '/monthEndClose',
                auth: this.getAuthConfig('MonthEndClose'),
                module: ['monthEndClose']
              },
              {
                name: this.$t('announcement'), // May cause model name & menu item id 
                link: '/announcementSettings',
                disabled: this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('announcementSettings'),
                module: ['announcement']
              },
              {
                name: this.$t('sorting'),
                link: '/Sorting',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('Sorting')
              },
              {
                name: this.$t('appleOrders'), // May cause model name & menu item id 
                link: '/AppleOrders',
                disabled: this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('AppleOrders')
              },
              {
                name: this.$t('labelMapping'), // May cause model name & menu item id 
                link: '/LabelMapping',
                disabled: !this.labelMapping,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('labelMapping')
              },
              {
                name: this.$t('weChatBilling'), // May cause model name & menu item id 
                link: '/WeChatBilling',
                disabled: this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('WeChatBilling')
              },
              {
                name: this.$t('amazonOTP'),
                link: '/TrackingOTP',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('TrackingOTP')
              },
              {
                name: this.$t('ProductRecords'),
                link: '/ProductRecords',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('ProductRecords')
              },
              {
                name: this.$t('exportClientTransactions'),
                link: '/ExportClientTransactions',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('ExportClientTransactions'),
                disabled: !this.betaFeatures.includes('exportClientTransactions')
              }
            ]
          },
          {
            name: this.$t('warehouse'),
            isShownOnSmallDevices: true,
            disabled: this.isWarehouse || this.isAdmin,
            subItems: [
              {
                name: this.$t('inventory'),
                link: this.isUserTenant ? '/inventoryTenant' : '/inventoryUser',
                isShownOnSmallDevices: true,
                auth: this.isUserTenant ? this.getAuthConfig('inventoryTenant') : this.getAuthConfig('inventoryUser'),
                module: this.isUserTenant ? [] : ['offerAndTask']
              },
              {
                name: this.$t('package'),
                link: '/package',
                disabled: (this.isUserTenant && this.isTenantHasDClassFeature),
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('package')
              },
              {
                name: this.$t('combinedUpc'),
                link: '/CombinedUpc',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('CombinedUpc'),
                module: ['offerAndTask']
              },
              {
                name: this.$t('package'),
                link: '/UserPackage',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('UserPackage'),
                disabled: this.isUserTenant,
                module: ['offerAndTask']
              },
              {
                name: this.$t('inboundRequest'),
                link: '/ForecastTenant',
                isShownOnSmallDevices: true,
                disabled: !this.isTenantForecastFeature && !this.hasAvailableToShip,
                auth: this.getAuthConfig('ForecastTenant'),
                module: ['forecast']
              },
              {
                name: this.$t('inboundForecastForNavbar'),
                link: '/boxes',
                isShownOnSmallDevices: true,
                disabled: !this.isTenantHasDClassFeature,
                auth: this.getAuthConfig('boxes'),
                module: ['forecast']
              },
              {
                name: this.$t('transfer'),
                link: '/productTransferTenant',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('productTransferTenant')
              },
              {
                name: this.$t('site'),
                link: '/WarehouseSite',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('WarehouseSite')
              },
              {
                name: this.$t('uploadPackages'),
                link: '/tenantUploadPackage',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('tenantUploadPackage')
              },
              {
                name: this.$t('export'),
                link: '/packageReportTenant',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('packageReportTenant')
              },
              {
                name: this.$t('amazonOTP'),
                link: '/UserTrackingOTP',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('UserTrackingOTP')
              }
            ],
            module: ['label', 'shipment']
          },
          {
            name: this.$t('payment'),
            link: this.isUserTenant ? '/paymentTenant' : '/paymentUser',
            isShownOnSmallDevices: true,
            auth: this.isUserTenant ? this.getAuthConfig('paymentTenant') : this.getAuthConfig('paymentUser'),
            module: ['offerAndTask']
          },
          {
            name: this.$t('setting'),
            isShownOnSmallDevices: true,
            subItems: [
              {
                name: this.$t('general'),
                link: this.isWarehouse ? '/warehouseGeneralSettings' : '/generalSettings',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig(this.isWarehouse ? 'warehouseGeneralSettings' : 'generalSettings')
              },
              {
                name: this.$t('organization'),
                link: '/organization',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('organization')
              },
              {
                name: `${this.$t('orgProduct')}`,
                link: '/productWarehouse',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('productWarehouse')
              },
              {
                name: this.$t('upc'),
                link: '/upc',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('upc')
              },
              {
                name: this.$t('warehouseSite'),
                link: '/warehouse',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('warehouse')
              },
              {
                name: this.$t('staff'),
                link: this.isWarehouse ? '/permissions' : '/permissionsTenant',
                isShownOnSmallDevices: true,
                auth: this.isWarehouse ? this.getAuthConfig('permissions') : this.getAuthConfig('permissionsTenant')
              },
              {
                name: this.$t('member'),
                link: '/member',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('member'),
                module: ['offerAndTask']
              },
              {
                name: this.$t('shipping'),
                link: '/shippingSettings',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('shippingSettings'),
                module: ['shipment']
              },
              {
                name: this.$t('fee'),
                link: '/billingSettings',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('billingSettings')
              },
              {
                name: this.$t('packing'),
                link: '/warehousePacking',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('WarehousePacking')
              },
              {
                name: this.$t('promotion'),
                link: '/promotionSettings',
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('promotionSettings')
              },
              {
                name: this.$t('store'), // May cause model name & menu item id 
                link: '/storeSettings',
                disabled: !this.isUserTenant,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('storeSettings')
              }
            ]
          },
          {
            name: this.$t('registration'),
            link: '/administrator',
            disabled: !this.isAdmin,
            auth: this.getAuthConfig('administrator')
          },
          {
            name: this.$t('staff'),
            link: '/permissionAdmin',
            isShownOnSmallDevices: true,
            auth: this.getAuthConfig('permissionAdmin')
          },
          {
            name: this.$t('trackingMonitor.nav'),
            link: '/trackingMonitorDashboard',
            isShownOnSmallDevices: true,
            disabled: !(this.isUserTenant || this.isAdmin),
            auth: this.getAuthConfig('trackingMonitorDashboard')
          },
          {
            name: this.$t('statistics'),
            link: '/businessDashboard',
            isShownOnSmallDevices: true,
            disabled: !(this.isUserTenant || this.isAdmin),
            auth: this.getAuthConfig('BusinessDashboard')
          },
          {
            name: this.$t('tools'),
            isShownOnSmallDevices: true,
            subItems: [
              {
                name: this.$t('documentsManagement'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/op950Documents',
                auth: this.getAuthConfig('OP950Documents')
              },
              {
                name: this.$t('authorizationSites'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/authorizationSites',
                auth: this.getAuthConfig('HazmatAuthorizationSites'),
                module: ['label', 'shipment']
              },
              {
                name: this.$t('proofDeliveryHistory'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/proofDeliveryHistory',
                auth: this.getAuthConfig('proofDeliveryHistory')
              },
              {
                name: this.$t('support'),
                link: '/support',
                disabled: !this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('support')
              },
              {
                name: this.$t('weChatBilling'), // May cause model name & menu item id 
                link: '/WeChatBilling',
                disabled: !this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('WeChatBilling')
              },
              {
                name: this.$t('announcement'), // May cause model name & menu item id 
                link: '/announcementSettings',
                disabled: !this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('announcementSettings'),
                module: ['announcement']
              },
              {
                name: this.$t('user'),
                link: '/userSettings',
                disabled: !this.isAdmin,
                isShownOnSmallDevices: true,
                auth: this.getAuthConfig('userSettings')
              },
              {
                name: this.$t('returnPackages'),
                link: '/returnPackages',
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                auth: this.getAuthConfig('ReturnPackages')
              },
              {
                name: this.$t('statistics'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/Statistics',
                auth: this.getAuthConfig('Statistics')
              },
              {
                name: this.$t('abnormalStatistics.nav'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/AbnormalStatistics',
                auth: this.getAuthConfig('AbnormalStatistics')
              },
              {
                name: this.$t('systemTransaction'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/SystemTransaction',
                auth: this.getAuthConfig('SystemTransaction')
              },
              {
                name: this.$t('usdtAutoRecharge'),
                link: '/chainRechargeRequests',
                isShownOnSmallDevices: true,
                disabled: !this.hasAuthToFunctionality('sysBillingRechargeRequests'),
                auth: this.getAuthConfig('chainRechargeRequests')
              },
              {
                name: this.$t('salesSettings'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/salesSettings',
                auth: this.getAuthConfig('salesSettings')
              },
              {
                name: this.$t('commonCommoditySettings'),
                isShownOnSmallDevices: true,
                disabled: !this.isAdmin,
                link: '/commonCommoditySettings',
                auth: this.getAuthConfig('commonCommoditySettings')
              }
            ]
          }
        ]
        menuItems = this.filterMenu(this.roles, menuItems)
      }
      // 先进行子菜单过滤，后再进行母菜单过滤
      return getConditionalRoutesWithDifferentEnv(menuItems, this.env).filter(item => {
        const subItems = item.subItems
        const hasSubItems = Array.isArray(subItems)
        return !(hasSubItems && (!subItems.length || subItems.every(sub => sub.disabled)))
      })
    },
    isAdmin () {
      return this.$store.getters.user && this.$store.getters.user.isAdmin
    },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    betaFeatures () {
      return this.$store.getters.betaFeatures
    },
    isUserLogined () {
      return !this.$store.getters.userLoading && this.$store.getters.user
    },
    isUserTenant () {
      return this.$store.getters.activeOrganization
    },
    accounts () {
      return this.$store.getters.userExtra?.accounts || 
      this.$store.getters.mainAccount?.accounts?.filter(account => 
        account.email !== (this.$store.getters.userExtra && this.$store.getters.userExtra.email))
       || []
    },
    // this is regular user type
    isUser () {
      return (this.$store.getters.userExtra && this.$store.getters.userExtra.role === 1)
    },
    isTenantHasDClassFeature () {
      const { featureInboundForecastDropshipping } = this.$store.getters.tenant || {}
      return !!featureInboundForecastDropshipping?.length
    },
    isWarehouseHasDClassUser () {
      const {featureInboundForecastDropshipping = []} = this.$store.getters.warehouseInfo || {}
      return !!featureInboundForecastDropshipping.length
    },
    isWarehouseForecastFeature () {
      const {featureInboundForecast = [], featureInboundForecastPkg = [], featureInboundForecastDropshipping = []} = this.$store.getters.warehouseInfo || {}
      return !!(featureInboundForecast?.length || featureInboundForecastPkg?.length || featureInboundForecastDropshipping?.length)
    },
    isAWarehouseForecastFeature () {
      const {featureInboundForecast = [], featureInboundForecastPkg = []} = this.$store.getters.warehouseInfo || {}
      return !!(featureInboundForecast?.length || featureInboundForecastPkg?.length)
    },
    isTenantForecastFeature () {
      const {featureInboundForecast, featureInboundForecastPkg, featureInboundForecastDropshipping} = this.$store.getters.tenant || {}
      return !!(featureInboundForecast?.length || featureInboundForecastPkg?.length || featureInboundForecastDropshipping?.length)
    },
    isShowMonthEndClose () {
      const { isAutoMonthEndClose = false } = this.$store.getters.tenantLimitedInfo
      return (thirdPartModuleConfig[this.env] || thirdPartModuleConfig['viteusa']).includes('monthEndClose') && isAutoMonthEndClose
    },
    // this is regular user except for warehouse worker
    isJustUser () {
      return (this.$store.getters.userExtra && this.$store.getters.userExtra.role === 1) && !this.isWarehouse && !this.isUserTenant
    },
    isSysUpdating () {
      return this.$store.getters.isSysUpdating
    },
    isReloadNeeded () {
      return this.$store.getters.reloadPage && !this.isSysUpdating
    },
    isWarehouse () {
      return this.$store.getters.activeWarehouse
    },
    isWarehouseWorker () {
      return this.$store.getters.activeWarehouse && this.$store.getters.warehouseInfo.users && this.$store.getters.user.email !== this.$store.getters.warehouseInfo.users[0].email
    },
    version () {
      return process.env.version
    },
    toastEnable () {
      return this.$store.getters.toastEnable
    },
    toastText () {
      return this.$store.getters.toastText
    },
    toastColor () {
      return this.$store.getters.toastColor
    },
    userIcon () {
      if (!this.isUserLogined) {
        return ''
      } else if (this.isAdmin) {
        return 'supervisor_account'
      } else if (this.$store.getters.activeWarehouse) {
        return 'local_shipping'
      } else if (this.$store.getters.activeOrganization) {
        return 'business'
      } else {
        return 'perm_identity'
      }
    },
    reloadPageText () {
      return this.$t('newVersion', { newVersion: this.$store.getters.newVersion })
    },
    updatingText () {
      return (this.currentLang === 'en' ? this.$store.getters.updatingText : this.$store.getters.updatingTextCn) || this.$t('updating')
    },
    supportNew () {
      return this.$store.getters.supports.length
    },
    activatePrescan () {
      return this.$store.getters.activatePrescan
    },
    existApplication () {
      const {application} = this.$store.getters.tenantLimitedInfo
      return !!(application && application.status && application.status === 'pending')
    },
    featureApplication () {
      return this.$store.getters.featureApplication
    },
    labelMapping () {
      return this.$store.getters.systemBalance?.labelMapping
    },
    applyFeature () {
      let applyFeature
      this.items.forEach(item => {
        if (item.link === this.$route.path && item.needApplication) {
          applyFeature = item
        }
        if (item.subItems) {
          let feature = item.subItems.find(subItem => {
            return subItem.link === this.$route.path && subItem.needApplication
          })
          applyFeature = feature || applyFeature
        }
      })
      return applyFeature
    }
  },
  methods: {
    toTimestampString: toTimestampString,
    isShowLogo (env) {
      if (Object.keys(thirdPartModuleConfig).includes(env)) {
        return this.env === env
      } else {
        return !this.isThreePartEnv
      }
    },
    staffIcons (role) {
      switch (role) {
        case 0:
          return 'business'
        case 1:
          return 'perm_identity'
        case 2:
          return 'local_shipping'
        default: 
          return 'supervisor_account'
      }
    },
    switchToAccount (name) {
      if (!confirm(this.$t('ConfirmToStaff', {name: name.split('--Individual')[0]}))) return
      let switchToName = btoa(encodeURIComponent(name))
      let url = `${location.origin}${location.pathname}?name=${switchToName}`
      open(url)
    },
    getAuthConfig (key) {
      return routeDefinition && routeDefinition[key] && routeDefinition[key].meta && routeDefinition[key].meta.auth
    },
    filterMenu (roles, items) {
      let newItems = []
      items.forEach(item => {
        if (item.subItems && item.subItems.length > 0) {
          let newSubItems = this.filterMenu(roles, item.subItems)
          if (newSubItems.length > 0) {
            newItems.push({...item, subItems: newSubItems})
          }
        } else if (item.auth) {
          if (roles.some(role => item.auth.includes(role))) {
            newItems.push(item)
          }
        } else {
          newItems.push(item)
        }
      })
      return newItems
    },
    getManualClass (item) {
      if (item.subItems) {
        return item.subItems.some(subItem => subItem.link === this.$route.path) ? 'v-btn--active' : ''
      } else {
        return item.link === this.$route.path ? 'v-btn--active' : ''
      }
    },
    reloadPage () {
      location.reload(true)
    },
    cancelReload () {
      this.$store.commit('setReloadPage', false)
    },
    async onLogout () {
      if (!confirm('Are you sure you want to log out?')) return
      try {
        this.submitting = true
        await this.$store.dispatch('logout')
      } catch (err) {
        console.error('fail to logout: ', err.message)
      } finally {
        this.submitting = false
      }
    },
    closeToast () {
      this.$store.dispatch('closeToast')
    },
    showAnnouncement () {
      this.announcementToggle = !this.announcementToggle
    },
    switchLang () {
      const lang = this.currentLang === 'en' ? 'zhHans' : 'en'
      window.localStorage.setItem('lang', lang)
      // this.currentLang = lang
      // this.$i18n.locale = lang
      // this.$vuetify.lang.current = lang
      window.location.reload()
    },
    menuClick (item) {
      this.$router.push(item.link)
    },
    downloadTemplate () {
      this.$store.dispatch('downloadFile', {fullPath: 'templates/application-template.xlsx', name: 'application-template.xlsx'})
    },
    submitApplication () {
      let payload = {
        name: this.$store.getters.tenantLimitedInfo.name || '',
        clientKey: this.$store.getters.activeOrganization || '', 
        uploadFiles: this.uploadFiles,
        feature: this.applyFeature.feature,
        link: this.applyFeature.link,
        status: 'pending'
      }
      this.$store.dispatch('submitApplication', payload)
        .then(result => {
          this.$store.dispatch('showToast', { info: this.$t('submitApplicationSuccess'), level: 'success' })
          this.goBack()
        })
        .catch(error => {
          this.$store.dispatch('showToast', { info: `${this.$t('submitApplicationFailed')}: ${error}`, level: 'error' })
          this.goBack()
        })
    },
    showCommentsDialog () {
      this.commentsDialog = true
    },
    goBack () {
      this.$router.back()
    }
  }
}
</script>

<style>
.notification .v-badge__badge{
  width: 5px;
  height: 5px;
  top: -3px;
  right: -5px;
}
.farImgClass {
  filter: invert(1) brightness(1.5) saturate(5);
}
.title {
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue